"use strict";

exports.__esModule = true;
exports.getThemeVarTypes = getThemeVarTypes;
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var patterns = [[/intent/i, "color"], [/background/i, "background"], [/color/i, "color"], [/border/i, "border"], [/padding/i, "padding"], [/outline/i, "outline"], [/(width|height|fontsize)/i, "size"]];

/**
 * Get a dictionary of css type names for the given theme definition.
 */
function getThemeVarTypes(theme) {
  var collected = {};
  for (var _i = 0, _Object$keys = Object.keys(theme); _i < _Object$keys.length; _i++) {
    var varName = _Object$keys[_i];
    var value = theme[varName];
    if (typeof value !== "string" && typeof value !== "number") {
      continue;
    }
    var varType = getThemeVarType(varName);
    if (varType !== undefined) {
      collected[varName] = varType;
    }
  }
  return collected;
}
function getThemeVarType(varName) {
  for (var _iterator = _createForOfIteratorHelperLoose(patterns), _step; !(_step = _iterator()).done;) {
    var _step$value = _step.value,
      pattern = _step$value[0],
      type = _step$value[1];
    if (pattern.test(varName)) {
      return type;
    }
  }
}